export default "__VITE_ASSET__DftS2HnU__"